export default __webpack_public_path__ + "static/media/burger.779aec12.svg";